<template>
  <p>For all inquiries relating to the conference program or sponsorship, please contact the VIZBI
    chairs and organizers:
  </p>
  <Email to="vizbi-contact" :outstanding="true" />
  <p>For inquiries about practical matters (registration, transport, etc.), please contact the
    Broad events team:
  </p>
  <p style="margin-left: 2.5em;">
    <a href="mailto:vizbi2018@broadinstitute.org">vizbi2018@broadinstitute.org</a><br /><br />
    Tel: +1 617-714-7000<br /><br />
    415 Main Street<br />
    Cambridge MA 02142
  </p>
  <p>For inquiries related to the conference hotel, contact Lauren Hendy at the
    <a href="http://www.hotelmarlowe.com/">Kimpton Marlowe Hotel</a>:
  </p>
  <p style="margin-left: 2.5em;">
    <a href="mailto:Lauren.Hendy@hotelmarlowe.com">Lauren.Hendy@hotelmarlowe.com</a><br /><br />
    Tel: +1 617-395-2556<br /><br />
    25 Edwin H. Land Blvd<br />
    Cambridge MA 02141
  </p>
</template>

<script setup>
import Email from "@/components/Email.vue";
</script>

<style scoped>
p:not(:first-child) {
  margin-top: 18px;
}
</style>
